import React from "react"
import CardTravelIcon from "@mui/icons-material/CardTravel"
import LocalShippingIcon from "@mui/icons-material/LocalShipping"
import { Tooltip, Typography } from "@mui/material"
import { packagingParticularities } from "../../utils/packagingExecutions"

const PackagingParticularity = ({ particularity, particularities = [] }) => {
  const allParticularities = [particularity, ...particularities]
  if (allParticularities.includes(packagingParticularities.nationalSend)) {
    return (
      <Tooltip title="Envoi en province">
        <LocalShippingIcon />
      </Tooltip>
    )
  }

  if (allParticularities.includes(packagingParticularities.lunchbag)) {
    return (
      <Tooltip title="Lunchbag">
        <CardTravelIcon />
      </Tooltip>
    )
  }

  return <Typography sx={{ fontSize: "16px", fontWeight: 400 }}>-</Typography>
}

export default PackagingParticularity